/**
 * @file dignding分享
 * @author liudy
 */

import { IShareConfig } from '@umu/umu-types';
import { BaseShare } from './baseShare';
import * as dd from 'dingtalk-jsapi';

export class DingdingShare extends BaseShare {
    public constructor() {
        super();
    }

    /**
     * @desc 更新微信与app参数
     * @param wxConfig 微信参数
     */
    public setup(dingdingConfig?: IShareConfig) {
        this.mergeSetup(dingdingConfig);

        dd.ready(() => {
            dd.biz.navigation.setRight({
                show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
                control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
                text: '', // 控制显示文本，空字符串表示显示默认文本
                onSuccess: () => {
                    // 如果control为true，则onSuccess将在发生按钮点击事件被回调
                    dd.biz.util.share({
                        type: 0,
                        url: this.shareConfig.shareUrl,
                        title: this.shareConfig.title,
                        content: this.shareConfig.desc,
                        image: this.shareConfig.imgUrl,
                    });
                },
            });
        });
    }
}
